import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getOperatorId, handleChange, handleError, isProd, trimField} from '../Shared/Functions';
import ReCAPTCHA from "react-google-recaptcha";
import { UserUtilityVService, CaptchaService } from '../../services/V2/keymaster';

export function ForgotPassword({ hide, show, fail, success }) {
    const recaptchaRef: any = React.useRef();
    
    const [user, setUser] = useState<any>();
    const [setToken, setSetToken] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getOperatorId()
            .then(x => setUser({
                ...user,
                operatorId: x
            }))
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const send = async () => {
        var token = setToken;
        if(!setToken){
            await recaptchaRef?.current?.reset();
            token = await recaptchaRef?.current?.executeAsync();
            setSetToken(token)
        }
        CaptchaService.captchaValidate(token)
            .then(x => {
                if(x.success) {
                    setLoading(true);
                    UserUtilityVService.userUtilityVPasswordRecovery(user)
                        .then(x => {
                            success("Check your email for Link to change your password.")
                            hide();
                            setLoading(false);
                        })
                        .catch(x => {
                            fail(handleError(x))
                            setLoading(false)
                            setSetToken(null)
                        })
                } else {
                    fail("An error occurred validating the reCaptcha. Please refresh the page to try again. If errors persist, please contact support.")
                    setLoading(false);
                    setSetToken(null)
                }
            })
    }

    return <>
        <Dialog onClose={hide} open={show}>
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={isProd() ? "6LdysiEhAAAAAPZwsLD0CCf4U8yJvrD6pkuGuTHw" : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
            />
            <DialogTitle>Forgot Password</DialogTitle>
            <DialogContent>
                <TextField
                    onChange={e => handleChange(e, user, setUser)}
                    onBlur={e => trimField(e, user, setUser)}
                    margin="normal"
                    id="email"
                    name="email"
                    label="Email"
                    type="email"
                    autoComplete="email"
                    value={user?.email ?? ""}
                    fullWidth
                />
                <TextField
                    onChange={e => handleChange(e, user, setUser)}
                    onBlur={e => trimField(e, user, setUser)}
                    margin="normal"
                    id="username"
                    name="username"
                    label="Username"
                    type="text"
                    autoComplete="username"
                    value={user?.username ?? ""}
                    fullWidth
                />
                <TextField
                    onChange={e => handleChange(e, user, setUser)}
                    onBlur={e => trimField(e, user, setUser)}
                    margin="normal"
                    id="accountNumber"
                    name="accountNumber"
                    label="Account Number"
                    type="text"
                    value={user?.accountNumber ?? ""}
                    fullWidth
                    autoComplete="off"
                />
            </DialogContent>
            <DialogActions className='forgot-info-buttons-group'>
                <Button variant="outlined" onClick={hide} style={{marginRight:"10px"}}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={send}>
                    Send
                </Button>
            </DialogActions>
            {loading && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        </Dialog>
    </>
}
